export default {
  main: '#DE291D',
}